import React, { useEffect, useState } from 'react';
import { StateType } from 'reducer';
import { usePersistRFVReducer } from 'reducer/reasonForVisit';
import { PodiatryConditionalOptionsType } from 'types/types';
import styles from 'components/podiatry/page.module.scss';
import MetaTag from 'components/meta';
import Button from 'components/common/button';

const numberOfRange = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
const units = ['Day(s)', 'Week(s)', 'Month(s)', 'Year(s)'];

type Props = {
  options: PodiatryConditionalOptionsType | PodiatryConditionalOptionsType[];
  currentPage?: number;
  nextPage: number;
  isFilter: boolean;
  actionPage: string;
  nextOrSubmitButton: (nextPage: number, submit?: boolean) => void;
};

const titleExperiencing = 'How long did you have physical therapy?';

function HowLongDidPhysicalTherapy({
  actionPage,
  nextPage,
  nextOrSubmitButton,
}: Props) {
  const [errorOnProblem, setErrorOnProblem] = useState(false);
  const [number, setNumber] = useState<string | null>(
    numberOfRange[0].toString(),
  );
  const [unitOfNumber, setUnitOfNumber] = useState<string | null>(units[0]);

  const [state, dispatch] = usePersistRFVReducer();
  useEffect(() => {
    if (state) {
      const data = state.find((object: StateType) => object.name === actionPage);
      if (data.value.length > 0) {
        setNumber(data.value[0]);
        setUnitOfNumber(data.value[1]);
      } else {
        setNumber(numberOfRange[0].toString());
        setUnitOfNumber(units[0]);
      }
    }
  }, []);

  const clickNextOrSubmit = async (nextPage: number) => {
    if (!number || !unitOfNumber) {
      setErrorOnProblem(true);
      return;
    }

    await dispatch({
      type: actionPage,
      name: titleExperiencing,
      value: [number, unitOfNumber],
    });

    nextOrSubmitButton(nextPage);
  };

  const onChangeNumber = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setNumber(event.target.value);
  };
  const onUnitNumber = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setUnitOfNumber(event.target.value);
  };

  return (
    <>
      <MetaTag title={titleExperiencing} />
      <h2 className={`marginTopZero ${styles.titleText}`}>
        {titleExperiencing}
      </h2>
      {errorOnProblem && (
      <p className="error-message">
        Required. Please select both of these options.
      </p>
      )}
      <div className="flex">
        <div className="flex justify-between gap-3 w-full">
          <div className="w-1/2">
            {/* Number of range */}
            <select
              value={number || ''}
              onChange={onChangeNumber}
              style={{ width: '100%' }}
              className={styles.select}
            >
              {numberOfRange.map((name) => (
                <option
                  key={name}
                  value={name}
                >
                  {name}
                </option>
              ))}
            </select>
          </div>
          <div className="w-1/2">
            {/* units */}
            <select
              value={unitOfNumber || ''}
              onChange={onUnitNumber}
              style={{ width: '100%' }}
              className={styles.select}
            >
              {units.map((name) => (
                <option key={name} value={name}>
                  {name}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      <div className="next-button-fixed">
        <Button onClick={() => clickNextOrSubmit(nextPage)}>
          Next
        </Button>
      </div>
    </>
  );
}

export default HowLongDidPhysicalTherapy;
